import { useCallback, useMemo } from 'react';
import { UseRefinementListProps } from 'react-instantsearch';
import { deriveClothingGroupAndValueFromName } from './utils';

const useClothingSizeSorter = (displayLogging = false, locale = 'en') => {
  const collator = useMemo(
    () => new Intl.Collator(locale, { sensitivity: 'base' }),
    [locale]
  );
  const clothingSizeSorter: UseRefinementListProps['sortBy'] = (a, b) => {
    const [groupA, valueA] = deriveClothingGroupAndValueFromName(
      a.name,
      displayLogging
    );
    const [groupB, valueB] = deriveClothingGroupAndValueFromName(
      b.name,
      displayLogging
    );

    // Compare group priorities first
    if (groupA !== groupB) {
      return groupA - groupB;
    }

    // If group priorities are the same, compare values within the group
    if (typeof valueA === 'string' && typeof valueB === 'string') {
      return collator.compare(valueA, valueB);
    }
    if (valueA < valueB) return -1;
    if (valueA > valueB) return 1;

    // If all else is equal, consider them equal
    return 0;
  };

  const customSort = useCallback(clothingSizeSorter, [
    collator,
    displayLogging,
  ]);

  return customSort;
};

export default useClothingSizeSorter;
